export const normalizeKey = (k) => String(k || '').toLowerCase().replace(/[^a-z0-9]/g, '');

export const getField = (row, candidates) => {
  if (!row) return undefined;
  for (const c of (candidates || [])) {
    if (Object.prototype.hasOwnProperty.call(row, c)) return row[c];
  }
  const entries = Object.entries(row);
  for (const c of (candidates || [])) {
    const want = normalizeKey(c);
    const hit = entries.find(([k]) => normalizeKey(k) === want);
    if (hit) return hit[1];
  }
  return undefined;
};

export const toNumber = (v) => {
  if (v === null || typeof v === 'undefined') return 0;
  if (typeof v === 'number') return Number.isFinite(v) ? v : 0;
  const s = String(v).trim();
  if (!s || s === '-' || s.toLowerCase() === 'null' || s.toLowerCase() === 'nan') return 0;
  const cleaned = s.replace(/,/g, '');
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : 0;
};

export const toPortString = (v) => {
  if (v === null || typeof v === 'undefined') return '-';
  const s = String(v).trim();
  if (!s || s === '-' || s.toLowerCase() === 'null' || s.toLowerCase() === 'nan' || s.toLowerCase() === 'n/a') return '-';
  const n = parseInt(s, 10);
  if (!Number.isFinite(n) || n < 0) return '-';
  return String(n);
};
